import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './ThankYou.module.css';
import { DesktopView } from './desktop/CreateParentProfile.desktop';
import { MobileView } from './mobile/CreateParentProfile.mobile';

export const CreateParentProfile = (): JSX.Element => {
  // Redux Hooks

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
    </React.Fragment>
  );
};
